import React, { useState, useEffect, useRef, useMemo } from "react";
import {
  Box,
  Grid,
  TextField,
  Button,
  Autocomplete,
  LinearProgress,
  Fade,
  Chip,
} from "@mui/material";
import Swal from "sweetalert2";
import {
  CommonSubHeader,
  useLocationHelpers,
  NavButton,
} from "../../Components/helpers/Helpers";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "../../api/axios";
import { buscarDuplicados } from "../../Components/helpers/ContactPlusClient/ContactNClientsHelpers";
import LoadingPage from "../../Components/Common/Loading/LoadingPage";
import { Card, CardContent, Typography, Tooltip } from "@mui/material";
import { Search } from "lucide-react";
import { ArrowBack, Info, PersonOutline } from "@mui/icons-material";
import { syncCasesCacheAfterMutation } from "../cache/casesCache";

const CompanyRequiredTooltip = ({ disabled, children, title }) => {
  return disabled ? (
    <Tooltip title={title} arrow>
      <Box component="span" sx={{ display: "block" }}>
        {children}
      </Box>
    </Tooltip>
  ) : (
    children
  );
};

const safeArray = (value) => (Array.isArray(value) ? value : []);
const toText = (value) =>
  typeof value === "string" ? value : value == null ? "" : String(value);
const getOptionId = (value) => Number(value?.id ?? 0);
const getPersonFullName = (option) =>
  `${toText(option?.name)} ${toText(option?.surname)}`.trim();

const Crear = ({
  setSelectedDataNewCase = () => {},
  transferState = false,
  dataClientTransfered = false,
}) => {
  const navigate = useNavigate();

  const { goPanel, goTable, buildTableUrl } = useLocationHelpers();

  const [options, setOptions] = useState({
    // offices: [],
    inssUsers: [],
    client_id: [],
    user_id: [],
    case_type: [],
    case_contract: [],
    companies: [],
  });

  const [searchParams] = useSearchParams();
  const clientId = searchParams.get("id");
  // const [loadingOptionsOffices, setLoadingOptionsOffices] = useState(false);
  // const [loadingOptionsINSS, setLoadingOptionsINSS] = useState(false);
  const [loadingOptionsClients, setLoadingOptionsClients] = useState(false);
  const [loadingOptionsLawyers, setLoadingOptionsLawyers] = useState(false);
  const [loadingOptionsCaseType, setLoadingOptionsCaseType] = useState(false);
  const [loadingOptionsContracts, setLoadingOptionsContracts] = useState(false);

  const [contactData, setContactData] = useState([]);

  const [clientSearch, setClientSearch] = useState({
    name: "",
    surname: "",
  });
  const [hasClientSearchExecuted, setHasClientSearchExecuted] = useState(false);
  const [isClientSearchTyping, setIsClientSearchTyping] = useState(false);
  const clientSearchDebounceRef = useRef(null);
  const clientResultsDropdownRef = useRef(null);

  const [dataCase, setDataCase] = useState({
    // idfisico: "",
    // offices: null,
    user_id: { name: "Seleccionar", surname: "", id: 0 },
    // inssUsers: null,
    client_id: null,
    case_type: { case_type: "Seleccionar", id: 0 },
    case_contract: null,
    company_id: null,
  });

  const [titularNoClientNoUserToSend, setTitularNoClientNoUserToSend] =
    useState(0);
  const [titularNoClientNoUserToShow, setTitularNoClientNoUserToShow] =
    useState(false);
  const [flag, setFlag] = useState(false);

  // Fetch data for the form
  const getData = async () => {
    setFlag(true);
    try {
      let url;
      let parametros = {};

      if (!clientId) {
        url = `${process.env.REACT_APP_API_URL}/cases/create`;
      } else if (Number(clientId)) {
        url = `${process.env.REACT_APP_API_URL}/cases/create`;
        parametros = { client_id: Number(clientId) };
      }

      if (dataClientTransfered?.id) {
        url = `${process.env.REACT_APP_API_URL}/cases/create`;
        parametros = { client_id: Number(dataClientTransfered?.id) };
      }
      // console.log(parametros, url);

      const response = await api.post(
        url,
        { client_id: parametros?.client_id } || null,
      );
      console.log(response);

      const {
        // officesList,
        lawyersListFullData,
        clientsListNames,
        // authInssList,
        casesTypeList,
        contractList,
        companiesList,
      } = response.data;

      const safeLawyersList = safeArray(lawyersListFullData);
      const safeClientsList = safeArray(clientsListNames);
      const safeCaseTypesList = safeArray(casesTypeList);
      const safeContractList = safeArray(contractList);
      const safeCompaniesList = safeArray(companiesList);

      const getValidLawyerFromClient = (client, lawyers) => {
        const relationLawyer = client?.lawyers_relation;
        const relationLawyerId = Number(relationLawyer?.id || 0);

        if (relationLawyerId <= 0) {
          return null;
        }

        const lawyerInList = safeArray(lawyers).find(
          (lawyer) => Number(lawyer?.id || 0) === relationLawyerId,
        );

        if (!lawyerInList) {
          return null;
        }

        const hasLawyerData = Boolean(
          toText(lawyerInList?.name).trim() ||
          toText(lawyerInList?.surname).trim(),
        );

        return hasLawyerData ? lawyerInList : null;
      };

      // console.log(response);

      // console.log(contractList);

      let clientData;

      if (clientId) {
        clientData = safeClientsList[0];

        // Buscar cliente para obtener case por medio de contacto que esta ligado al documento (nif)
        const baseUrlContact = `${process.env.REACT_APP_API_URL}/contacts/search`;

        const queryParamsContact = {
          company_id: clientData?.company_id,
          document: clientData?.nif,
        };

        // console.log(queryParamsContact);

        const { data } = await api.post(baseUrlContact, queryParamsContact);
        const contacts = safeArray(data?.contacts);

        // console.log(contacts);
        if (contacts.length > 0) {
          const caseTypeFromContact = safeCaseTypesList.find(
            (ct) => ct.id === contacts[0]?.case_type,
          );

          setDataCase((prev) => ({
            ...prev,
            case_type: caseTypeFromContact || null,
          }));
        }
        // End buscar cliente

        setDataCase((prevData) => ({
          ...prevData,
          ["user_id"]: getValidLawyerFromClient(clientData, safeLawyersList),
          ["client_id"]: clientData && clientData?.id != 0 ? clientData : null,
          ["company_id"]:
            clientData && clientData?.company_id != 0
              ? clientData?.company_relation
              : null,
        }));
      }

      setOptions({
        user_id: [
          { name: "Seleccionar", surname: "", id: 0 },
          ...safeLawyersList,
        ],
        client_id: [
          { name: "Seleccionar", surname: "", id: 0 },
          ...safeClientsList,
        ],
        case_type: [{ case_type: "Seleccionar", id: 0 }, ...safeCaseTypesList],
        case_contract: [
          { contract_title: "Seleccionar", id: 0 },
          ...safeContractList,
        ],
        companies: [
          { company_name: "Seleccionar", id: 0 },
          ...safeCompaniesList,
        ],
      });
    } catch (error) {
      console.log(error);
    } finally {
      setFlag(false);
    }
  };

  const filteredClients = useMemo(() => {
    const selectedCompanyId = Number(dataCase?.company_id?.id || 0);

    if (!selectedCompanyId) {
      return options.client_id;
    }

    return options.client_id.filter(
      (c) => c.id === 0 || Number(c.company_relation?.id) === selectedCompanyId,
    );
  }, [dataCase?.company_id, options.client_id]);

  const filteredCaseTypes = useMemo(() => {
    const selectedCompanyId = Number(dataCase?.company_id?.id || 0);

    if (!selectedCompanyId) {
      return options.case_type;
    }

    return options.case_type.filter(
      (t) => Number(t.company_id) === selectedCompanyId || t.id === 0,
    );
  }, [dataCase?.company_id, options.case_type]);

  const filteredLawyers = useMemo(() => {
    const selectedCompanyId = Number(dataCase?.company_id?.id || 0);

    if (!selectedCompanyId) {
      return options.user_id;
    }

    return options.user_id.filter(
      (u) => Number(u.company_id) === selectedCompanyId || u.id === 0,
    );
  }, [dataCase?.company_id, options.user_id]);

  const filteredCaseContracts = useMemo(() => {
    const selectedCompanyId = Number(dataCase?.company_id?.id || 0);

    if (!options.case_contract || !options.case_contract.length) {
      return [];
    }

    if (!selectedCompanyId) {
      return options.case_contract;
    }

    return options.case_contract;
  }, [dataCase?.company_id, options.case_contract]);

  const isCompanySelected = useMemo(() => {
    return Boolean(dataCase?.company_id && dataCase?.company_id?.id !== 0);
  }, [dataCase?.company_id]);

  const isBlockedByMissingCompany = useMemo(() => {
    return !isCompanySelected && !Boolean(clientId);
  }, [isCompanySelected, clientId]);

  const companyRequiredMessage =
    "Debe seleccionar una empresa primero para habilitar otros campos.";

  const clientSearchResults = useMemo(() => {
    return safeArray(options.client_id).filter(
      (client) => client && Number(client?.id) !== 0,
    );
  }, [options.client_id]);

  const shouldShowClientDropdown = useMemo(() => {
    if (!isCompanySelected || Boolean(clientId)) {
      return false;
    }

    return (
      isClientSearchTyping || loadingOptionsClients || hasClientSearchExecuted
    );
  }, [
    isCompanySelected,
    clientId,
    isClientSearchTyping,
    loadingOptionsClients,
    hasClientSearchExecuted,
  ]);

  useEffect(() => {
    if (!isCompanySelected || clientId) return;

    setClientSearch({ name: "", surname: "" });

    setOptions((prev) => ({
      ...prev,
      client_id: [],
    }));

    setDataCase((prev) => ({
      ...prev,
      client_id: null,
      user_id: null,
      case_type: null,
      case_contract: null,
    }));
  }, [dataCase?.company_id]);

  useEffect(() => {
    getData();
  }, [transferState]);

  useEffect(() => {
    if (transferState && dataCase?.client_id) {
      setSelectedDataNewCase(dataCase);
    }
  }, [dataCase, transferState]);

  useEffect(() => {
    if (
      Array.isArray(options.case_type) &&
      options.case_type.length > 0 &&
      (!dataCase?.case_type ||
        typeof dataCase?.case_type?.id === "undefined" ||
        dataCase?.case_type?.id !== 0)
    ) {
      setDataCase((prev) => ({
        ...prev,
        case_type: options.case_type[0],
      }));
    }
  }, [options.case_type]);

  // Form submit handler
  const handleCasesFormInformation = async () => {
    // console.log(dataCase);

    // Campos obligatorios explícitos para evitar falsos negativos cuando el valor
    // está undefined/null/objeto vacío y no solo cuando trae id=0.
    const requiredFieldNames = transferState
      ? ["company_id", "case_type", "case_contract"]
      : ["company_id", "case_type", "case_contract", "user_id", "client_id"];

    const isMissingRequiredAutocomplete = (value) => {
      if (!value || typeof value !== "object") {
        return true;
      }

      const id = Number(value?.id);
      return !Number.isFinite(id) || id <= 0;
    };

    const missingFields = requiredFieldNames.filter((fieldName) =>
      isMissingRequiredAutocomplete(dataCase?.[fieldName]),
    );

    const uniqueMissingFields = [...new Set(missingFields)];

    const allFieldsValid = uniqueMissingFields.length === 0;

    if (allFieldsValid) {
      const payload = {
        company_id: Number(dataCase?.company_id?.id || 0),
        user_id: Number(dataCase?.user_id?.id || 0),
        client_id: Number(dataCase?.client_id?.id || 0),
        case_type: Number(dataCase?.case_type?.id || 0),
        case_contract: Number(dataCase?.case_contract?.id || 0),
        transfer_id: Number(dataCase?.transfer_id || 0) || null,
      };

      const queryUrl = `${process.env.REACT_APP_API_URL}/cases/store`;

      Swal.fire({
        title: "¿Desea guardar los cambios?",
        icon: "warning",
        showDenyButton: true,
        confirmButtonColor: "#1ab394",
        cancelButtonColor: "#d33",
        reverseButtons: true,
        confirmButtonText: "Guardar",
        denyButtonText: `Volver`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          // ðŸŸ¡ **Mostrar Swal de carga**
          Swal.fire({
            title: "Guardando...",
            text: "Por favor espere",
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });

          try {
            const response = await api.post(queryUrl, payload);
            console.log(response);

            Swal.close(); // Cerrar loading

            if (response.data.error) {
              Swal.fire({
                title: "¡No se guardaron los cambios!",
                icon: "error",
                text: "Por favor intí©ntelo nuevamente",
                confirmButtonColor: "#1ab394",
              });
            } else {
              syncCasesCacheAfterMutation(response?.data?.cases_cache_version);

              // Fallback local para refrescar badge de mensajes tras crear expediente.
              window.dispatchEvent(new Event("messages:refresh-unread"));

              Swal.fire({
                title: "¡Guardado!",
                icon: "success",
                confirmButtonColor: "#1ab394",
                confirmButtonText: "Ver Expediente",
                allowOutsideClick: false,
                allowEscapeKey: false,
                showCancelButton: false,
                showConfirmButton: false,
                timer: 2000,
              }).then((result) => {
                navigate(
                  "/expedientes/ver?id=" + response.data.case_created.id,
                );
              });
            }
          } catch (error) {
            Swal.close(); // Cerrar loading si hay error
            console.error(error);

            Swal.fire({
              title: "Error",
              icon: "error",
              text: "No se pudo guardar el caso. Intí©ntelo nuevamente.",
              confirmButtonColor: "#1ab394",
            });
          }
        } else if (result.isDenied) {
          Swal.fire("¡Los cambios no han sido guardados!", "", "info");
        }
      });
    } else {
      // Mostrar mensaje de error con los campos faltantes
      const requiredFieldLabelFallback = {
        company_id: "Empresa",
        user_id: "Abogado",
        client_id: "Cliente",
        case_type: "Tipo de proceso",
        case_contract: "Hoja de Encargo/Contrato",
      };

      const missingFieldLabels = uniqueMissingFields
        .map((fieldName) => {
          return requiredFieldLabelFallback[fieldName] || fieldName;
        })
        .filter(Boolean)
        .map((label) => `<li>${label}</li>`)
        .join("");

      Swal.fire({
        title: "¡Error!",
        icon: "error",
        confirmButtonColor: "#1ab394",
        html: `Por favor complete los siguientes campos:<ul style="text-align: left";>${missingFieldLabels}</ul>`,
      });
    }
  };

  const handleChange = (event) => {
    setDataCase({
      ...dataCase,
      [event.target.name]: event.target.value.trim(),
    });
  };

  const handleAutocompleteChange = (event, value, fieldName) => {
    // console.log(value, fieldName);
    setDataCase((prevData) => ({
      ...prevData,
      [fieldName]: value,
    }));
  };

  const handleChangeCheckbox = (event) => {
    if (titularNoClientNoUserToShow == true) {
      setTitularNoClientNoUserToSend(!titularNoClientNoUserToSend);
      setTitularNoClientNoUserToShow(!titularNoClientNoUserToSend);
    } else {
      setTitularNoClientNoUserToSend(!titularNoClientNoUserToSend);
      setTitularNoClientNoUserToShow(!titularNoClientNoUserToShow);
    }
  };

  // Fields for the form
  const formFields = useMemo(() => {
    // {
    //   name: "idfisico",
    //   label: "Expediente Fisico",
    //   key: "idfisico",
    //   type: "text",
    // },
    // {
    //   name: "offices",
    //   label: "Despacho",
    //   key: "offices",
    //   type: "autocomplete",
    //   options: options.offices,
    //   loading: loadingOptionsOffices,
    //   isOptionEqualToValue: (option, value) =>
    //     option.office_name === value.office_name,
    //   getOptionLabel: (option) => option.office_name || "",
    //   transform: (value) => value.office_name, // función para transformación
    // },

    // {
    //   name: "inssUsers",
    //   label: "Autorizados INSS, Banco.. (Abogados Autorizados)",
    //   key: "inssUsers",
    //   type: "autocomplete",
    //   options: options.groups,
    //   loading: loadingOptionsOffices,
    //   isOptionEqualToValue: (option, value) => option.grupo === value.grupo,
    //   getOptionLabel: (option) => option.grupo || "",
    //   transform: (value) => value.grupo, // función para transformación
    // },
    var fieldsCommonConfig = [
      {
        name: "company_id",
        label: "Empresa",
        key: "company_id",
        type: "autocomplete",
        options: safeArray(options.companies),
        loading: false,
        disabled: clientId ? true : false,
        isOptionEqualToValue: (option, value) =>
          getOptionId(option) === getOptionId(value),
        getOptionLabel: (option) => toText(option?.company_name),
      },
      {
        name: "case_type",
        label: "Tipo de proceso",
        key: "case_type",
        type: "autocomplete",
        options: filteredCaseTypes,
        loading: loadingOptionsCaseType,
        disabled: !dataCase?.company_id && !clientId,
        isOptionEqualToValue: (option, value) =>
          getOptionId(option) === getOptionId(value),
        getOptionLabel: (option) => toText(option?.case_type),
      },

      {
        label: "Hoja de Encargo/Contrato",
        name: "case_contract",
        key: "case_contract",
        type: "autocomplete",
        options: filteredCaseContracts || null,
        loading: loadingOptionsContracts,
        disabled: !dataCase?.company_id && !clientId,
        isOptionEqualToValue: (option, value) =>
          getOptionId(option) === getOptionId(value),
        getOptionLabel: (option) => toText(option?.contract_title),
        renderOption: (props, option) => {
          const contractTitle = toText(option?.contract_title);
          const companyName = toText(option?.company_relation?.company_name);

          return (
            <li
              {...props}
              key={`${toText(option?.id) || "no-id"}-${contractTitle}`}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}>
                <span>{contractTitle}</span>
                {companyName && (
                  <Chip
                    sx={{ marginLeft: "10px" }}
                    label={companyName}
                    size="small"
                    color="primary"
                  />
                )}
              </div>
            </li>
          );
        },
        transform: (value) => value.contract_title,
      },
    ];
    if (!transferState) {
      fieldsCommonConfig.splice(1, 0, {
        name: "user_id",
        label: "Abogado",
        key: "user_id",
        type: "autocomplete",
        options: filteredLawyers || null,
        loading: loadingOptionsLawyers,
        disabled: !dataCase?.company_id && !clientId,
        isOptionEqualToValue: (option, value) =>
          getOptionId(option) === getOptionId(value),
        getOptionLabel: (option) => getPersonFullName(option),
        transform: (value) => getPersonFullName(value), // función para transformación
      });
      fieldsCommonConfig.splice(2, 0, {
        name: "client_id",
        label: "Cliente",
        key: "client_id",
        type: "autocomplete",
        options: filteredClients || null, //
        loading: loadingOptionsClients,
        disabled: !dataCase?.company_id && !clientId,
        isOptionEqualToValue: (option, value) =>
          getOptionId(option) === getOptionId(value),
        getOptionLabel: (option) => getPersonFullName(option),
      });
    }

    return fieldsCommonConfig;
  }, [
    options.companies,
    transferState,
    filteredClients,
    filteredLawyers,
    filteredCaseTypes,
    filteredCaseContracts,
    loadingOptionsClients,
    loadingOptionsLawyers,
    loadingOptionsCaseType,
    loadingOptionsContracts,
  ]);

  const searchClients = async (name, surname) => {
    try {
      setLoadingOptionsClients(true);

      const response = await api.post(
        `${process.env.REACT_APP_API_URL}/users/searchclientnames`,
        {
          name,
          surname,
          company_id: dataCase?.company_id?.id || null,
        },
      );

      // console.log(response);

      setOptions((prev) => ({
        ...prev,
        client_id: safeArray(response?.data?.clientsListNames),
      }));
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingOptionsClients(false);
    }
  };

  useEffect(() => {
    clearTimeout(clientSearchDebounceRef.current);

    if (!isCompanySelected || Boolean(clientId)) {
      setIsClientSearchTyping(false);
      return () => clearTimeout(clientSearchDebounceRef.current);
    }

    const name = clientSearch?.name?.trim() || "";
    const surname = clientSearch?.surname?.trim() || "";
    const hasMinChars = name.length >= 2 || surname.length >= 2;

    if (!hasMinChars) {
      setIsClientSearchTyping(false);
      setHasClientSearchExecuted(false);
      setOptions((prev) => ({
        ...prev,
        client_id: [],
      }));
      return () => clearTimeout(clientSearchDebounceRef.current);
    }

    setIsClientSearchTyping(true);
    clientSearchDebounceRef.current = setTimeout(async () => {
      setIsClientSearchTyping(false);
      setHasClientSearchExecuted(true);
      await searchClients(name, surname);
    }, 1500);

    return () => clearTimeout(clientSearchDebounceRef.current);
  }, [clientSearch?.name, clientSearch?.surname, isCompanySelected, clientId]);

  useEffect(() => {
    if (!shouldShowClientDropdown) return;

    const handleOutsideClick = (event) => {
      if (
        clientResultsDropdownRef.current &&
        !clientResultsDropdownRef.current.contains(event.target)
      ) {
        setHasClientSearchExecuted(false);
        setIsClientSearchTyping(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [shouldShowClientDropdown]);

  return (
    <div className="fatherContainer">
      {!transferState && (
        <CommonSubHeader title="Expedientes" subTitle="Crear" />
      )}
      {flag && <LoadingPage isLoading color="success" />}
      {!flag && (
        <Fade in timeout={1000}>
          <Box
            component="form"
            sx={{
              maxWidth: Boolean(clientId) ? "920px" : "1200px",
              margin: { xs: "10px", lg: "30px auto" },
              "& > :not(style)": {},
              textAlign: "left",
              boxShadow: "0px 0px 15px 0px #1800b926",
              backgroundColor: "white",
              borderRadius: "10px",
              padding: 3,
            }}
            noValidate
            autoComplete="off">
            <Grid container spacing={2} alignItems="flex-start">
              {Boolean(clientId) ? (
                <>
                  <Grid item xs={12}>
                    <Card
                      variant="outlined"
                      sx={{
                        borderColor: "#1ab394",
                        background:
                          "linear-gradient(180deg, #f3fcf9 0%, #ffffff 100%)",
                        marginBottom: "10px",
                      }}>
                      <CardContent
                        sx={{
                          flexDirection: "row",
                          display: "flex",
                          alignItems: "center",
                          gap: 1.2,
                          py: "12px !important",
                        }}>
                        <Box
                          sx={{
                            width: 34,
                            height: 34,
                            borderRadius: "50%",
                            bgcolor: "#e7f8f1",
                            color: "#1ab394",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}>
                          <PersonOutline fontSize="small" />
                        </Box>
                        <Typography
                          variant="subtitle2"
                          sx={{ color: "#1ab394", fontWeight: 700 }}>
                          Cliente vinculado al expediente
                        </Typography>
                        {dataCase?.client_id ? (
                          <Chip
                            color="success"
                            variant="outlined"
                            label={`${dataCase?.client_id?.name || ""} ${dataCase?.client_id?.surname || ""}`}
                          />
                        ) : (
                          <Typography
                            variant="caption"
                            sx={{ color: "text.secondary" }}>
                            Cargando cliente...
                          </Typography>
                        )}
                      </CardContent>
                    </Card>
                  </Grid>
                  {formFields.map((field, idx) => (
                    <Grid item xs={12} key={idx}>
                      <CompanyRequiredTooltip
                        title={companyRequiredMessage}
                        disabled={
                          isBlockedByMissingCompany &&
                          field?.name !== "company_id" &&
                          Boolean(field?.disabled)
                        }>
                        <Autocomplete
                          size="small"
                          value={dataCase[field?.name] || null}
                          disabled={field?.disabled}
                          getOptionKey={(option) => toText(option?.id)}
                          onChange={(event, value) =>
                            handleAutocompleteChange(event, value, field?.name)
                          }
                          options={safeArray(field?.options)}
                          loading={field?.loading}
                          isOptionEqualToValue={field?.isOptionEqualToValue}
                          getOptionLabel={field?.getOptionLabel}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label={field?.label}
                              autoComplete="new-password"
                              fullWidth
                            />
                          )}
                          renderOption={field?.renderOption}
                        />
                      </CompanyRequiredTooltip>
                    </Grid>
                  ))}
                </>
              ) : (
                <>
                  <Grid item xs={12} md={4}>
                    <Card
                      variant="outlined"
                      sx={{
                        borderColor: "#1ab394",
                        backgroundColor: "#f9fdfc",
                        boxShadow: "0 4px 14px rgba(26,179,148,0.08)",
                        overflow: "visible",
                        height: "100%",
                      }}>
                      <CardContent sx={{ pb: "16px !important" }}>
                        <Typography
                          variant="subtitle2"
                          sx={{
                            mb: 1,
                            color: "#1ab394",
                            fontWeight: 600,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 1,
                          }}>
                          <Search fontSize="small" />
                          Buscar cliente
                        </Typography>

                        <Typography
                          variant="caption"
                          sx={{
                            display: "block",
                            mb: 2,
                            color: "text.secondary",
                          }}>
                          Escriba primero el <strong>nombre</strong> y/o{" "}
                          <strong>apellido</strong>. Cuando haya coincidencias,
                          por favor seleccione un cliente.
                        </Typography>

                        <Grid container spacing={1}>
                          <Grid item xs={12}>
                            <CompanyRequiredTooltip
                              title={companyRequiredMessage}
                              disabled={isBlockedByMissingCompany}>
                              <TextField
                                label="Nombre"
                                size="small"
                                fullWidth
                                disabled={!isCompanySelected}
                                value={clientSearch.name}
                                onChange={(e) => {
                                  setHasClientSearchExecuted(false);
                                  setIsClientSearchTyping(true);
                                  setClientSearch((prev) => ({
                                    ...prev,
                                    name: e.target.value,
                                  }));
                                }}
                                onInput={() => {
                                  if (dataCase?.client_id) {
                                    setDataCase((prev) => ({
                                      ...prev,
                                      client_id: null,
                                    }));
                                  }
                                }}
                              />
                            </CompanyRequiredTooltip>
                          </Grid>
                          <Grid item xs={12}>
                            <CompanyRequiredTooltip
                              title={companyRequiredMessage}
                              disabled={isBlockedByMissingCompany}>
                              <TextField
                                label="Apellido"
                                size="small"
                                fullWidth
                                disabled={!isCompanySelected}
                                value={clientSearch.surname}
                                onChange={(e) => {
                                  setHasClientSearchExecuted(false);
                                  setIsClientSearchTyping(true);
                                  setClientSearch((prev) => ({
                                    ...prev,
                                    surname: e.target.value,
                                  }));
                                }}
                                onInput={() => {
                                  if (dataCase?.client_id) {
                                    setDataCase((prev) => ({
                                      ...prev,
                                      client_id: null,
                                    }));
                                  }
                                }}
                              />
                            </CompanyRequiredTooltip>
                          </Grid>
                          {dataCase?.client_id && (
                            <Grid item xs={12}>
                              <Box
                                sx={{
                                  px: 1.5,
                                  py: 0.5,
                                  border: "1px solid #eef3f5",
                                  borderRadius: "10px",
                                  backgroundColor: "#fff",
                                }}>
                                <Chip
                                  color="success"
                                  variant="outlined"
                                  label={`${dataCase?.client_id?.name || ""} ${dataCase?.client_id?.surname || ""}`}
                                  onDelete={() => {
                                    setDataCase((prev) => ({
                                      ...prev,
                                      client_id: null,
                                    }));
                                  }}
                                />
                              </Box>
                            </Grid>
                          )}
                          {shouldShowClientDropdown && (
                            <Grid item xs={12}>
                              <Box sx={{ position: "relative" }}>
                                <Box
                                  ref={clientResultsDropdownRef}
                                  sx={{
                                    position: "absolute",
                                    left: 0,
                                    right: 0,
                                    top: 0,
                                    zIndex: 9999,
                                    border: "1px solid #dbe5e8",
                                    borderRadius: "10px",
                                    backgroundColor: "#fff",
                                    boxShadow: "0 12px 24px rgba(0,0,0,0.12)",
                                    overflow: "hidden",
                                  }}>
                                  <Box
                                    sx={{
                                      px: 1.5,
                                      py: 1,
                                      bgcolor: "#f7faf9",
                                      borderBottom: "1px solid #eef3f5",
                                    }}>
                                    <Typography
                                      variant="caption"
                                      sx={{ color: "text.secondary" }}>
                                      Resultados de busqueda
                                    </Typography>
                                  </Box>

                                  {(isClientSearchTyping ||
                                    loadingOptionsClients) && (
                                    <LinearProgress color="success" />
                                  )}

                                  <Box
                                    sx={{
                                      maxHeight: 220,
                                      overflowY: "auto",
                                    }}>
                                    {!loadingOptionsClients &&
                                    clientSearchResults.length === 0 ? (
                                      <Box
                                        sx={{
                                          py: 2,
                                          px: 1.5,
                                          textAlign: "center",
                                          color: "text.secondary",
                                          fontSize: 13,
                                        }}>
                                        No se encontraron coincidencias.
                                      </Box>
                                    ) : (
                                      clientSearchResults.map((client) => (
                                        <Box
                                          key={client.id}
                                          role="button"
                                          tabIndex={0}
                                          onClick={() => {
                                            setDataCase((prev) => ({
                                              ...prev,
                                              client_id: client,
                                            }));
                                            setHasClientSearchExecuted(false);
                                            setClientSearch({
                                              name: "",
                                              surname: "",
                                            });
                                          }}
                                          onKeyDown={(event) => {
                                            if (event.key === "Enter") {
                                              setDataCase((prev) => ({
                                                ...prev,
                                                client_id: client,
                                              }));
                                              setHasClientSearchExecuted(false);
                                              setClientSearch({
                                                name: "",
                                                surname: "",
                                              });
                                            }
                                          }}
                                          sx={{
                                            px: 1.5,
                                            py: 1,
                                            cursor: "pointer",
                                            borderBottom: "1px solid #f0f2f5",
                                            textAlign: "left",
                                            "&:hover": {
                                              bgcolor: "#f8fdfb",
                                            },
                                            "&:last-child": {
                                              borderBottom: "none",
                                            },
                                          }}>
                                          <Typography
                                            sx={{
                                              fontSize: 14,
                                              fontWeight: 600,
                                            }}>
                                            {client?.name || ""}{" "}
                                            {client?.surname || ""}
                                          </Typography>
                                          <Typography
                                            sx={{
                                              fontSize: 12,
                                              color: "text.secondary",
                                            }}>
                                            {client?.nif || "Sin documento"}
                                          </Typography>
                                        </Box>
                                      ))
                                    )}
                                  </Box>
                                </Box>
                              </Box>
                            </Grid>
                          )}
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item xs={12} md={8}>
                    <Grid container spacing={2}>
                      {formFields
                        .filter((field) => field.name !== "client_id")
                        .map((field, idx) => (
                          <Grid item xs={12} key={idx}>
                            <CompanyRequiredTooltip
                              title={companyRequiredMessage}
                              disabled={
                                isBlockedByMissingCompany &&
                                field?.name !== "company_id" &&
                                Boolean(field?.disabled)
                              }>
                              <Autocomplete
                                size="small"
                                value={dataCase[field?.name] || null}
                                disabled={field?.disabled}
                                getOptionKey={(option) => toText(option?.id)}
                                onChange={(event, value) =>
                                  handleAutocompleteChange(
                                    event,
                                    value,
                                    field?.name,
                                  )
                                }
                                options={safeArray(field?.options)}
                                loading={field?.loading}
                                isOptionEqualToValue={
                                  field?.isOptionEqualToValue
                                }
                                getOptionLabel={field?.getOptionLabel}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label={field?.label}
                                    autoComplete="new-password"
                                    fullWidth
                                  />
                                )}
                                renderOption={field?.renderOption}
                              />
                            </CompanyRequiredTooltip>
                          </Grid>
                        ))}
                    </Grid>
                  </Grid>
                </>
              )}
            </Grid>

            <Box
              sx={{
                mt: 3,
                pt: 2,
                borderTop: "1px solid #e6ecef",
                display: "flex",
                justifyContent: "flex-end",
                gap: 1,
                flexWrap: "wrap",
              }}>
              <NavButton
                variant="outlined"
                color="error"
                to={buildTableUrl("expedientes")}
                onClick={() => goTable("expedientes", "expedientes")}>
                Tabla de expedientes
              </NavButton>

              {Boolean(clientId) && (
                <NavButton
                  variant="contained"
                  startIcon={<ArrowBack />}
                  sx={{
                    backgroundColor: "#0f766e",
                    color: "#fff",
                    "&:hover": {
                      backgroundColor: "#0b5f59",
                    },
                  }}
                  to={`/clientes/ver?id=${clientId}`}
                  onClick={() => navigate(`/clientes/ver?id=${clientId}`)}>
                  Volver al cliente
                </NavButton>
              )}

              <Button
                variant="contained"
                color="success"
                onClick={handleCasesFormInformation}>
                Guardar
              </Button>
            </Box>
          </Box>
        </Fade>
      )}
    </div>
  );
};

export default Crear;
